"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wheelAnalysis = exports.view = exports.vehicle = exports.task = exports.part = exports.inspection = exports.image = exports.damage = exports.damageArea = void 0;
var damageAreas_1 = require("./damageAreas");
Object.defineProperty(exports, "damageArea", { enumerable: true, get: function () { return __importDefault(damageAreas_1).default; } });
var damages_1 = require("./damages");
Object.defineProperty(exports, "damage", { enumerable: true, get: function () { return __importDefault(damages_1).default; } });
var images_1 = require("./images");
Object.defineProperty(exports, "image", { enumerable: true, get: function () { return __importDefault(images_1).default; } });
var inspections_1 = require("./inspections");
Object.defineProperty(exports, "inspection", { enumerable: true, get: function () { return __importDefault(inspections_1).default; } });
var parts_1 = require("./parts");
Object.defineProperty(exports, "part", { enumerable: true, get: function () { return __importDefault(parts_1).default; } });
var tasks_1 = require("./tasks");
Object.defineProperty(exports, "task", { enumerable: true, get: function () { return __importDefault(tasks_1).default; } });
var vehicles_1 = require("./vehicles");
Object.defineProperty(exports, "vehicle", { enumerable: true, get: function () { return __importDefault(vehicles_1).default; } });
var views_1 = require("./views");
Object.defineProperty(exports, "view", { enumerable: true, get: function () { return __importDefault(views_1).default; } });
var wheelAnalysis_1 = require("./wheelAnalysis");
Object.defineProperty(exports, "wheelAnalysis", { enumerable: true, get: function () { return __importDefault(wheelAnalysis_1).default; } });
//# sourceMappingURL=slices.js.map